import {
  Button,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { FID_LOGO } from "../DrawerAppBar";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../../service/AuthService";
import useToast from "../../../hooks/useToast";
import { isValidEmail } from "../../../Helpers/utilsHelper";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import useConfirm from "../../../hooks/useConfirm";
import useNotification from "../../../hooks/useNotification";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";

const ForgotPassword = () => {
  const { Toast, showToast } = useToast();
  const [loading, setloading] = useState(false);
  const [submited, setSubmitted] = useState(false);
  const [authData, setAuthData] = useState({ email: "", password: "" });
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { NotificationComponent, showNotification } = useNotification();
  const navigate = useNavigate();
  const [formError, setFormError] = useState({
    mailError: null,
    passwordError: null,
  });
  const isSubmitted = () => {
    return submited;
  };

  const handleActivateAccount = () => {
    openConfirmDialog(
      "Envoie de mail de confirmation",
      "Voullez vous recuperer votre mot de passe?",
      () => handleResendActivationMail(),
      true
    );
  };

  const handleResendActivationMail = () => {
    setloading(true);
    let authDataCopy = { ...authData };
    authDataCopy.type = 1;
    AuthService.resendActivationLink(authDataCopy)
      .then((res) => {
        if (res && res.success) {
          showNotification(
            "Information",
            res.message,
            TYPE_NOTIFICATION.INFO,
            () => {
              navigate("/login");
            }
          );
        }else{
          showNotification(
            "Erreur",
            res.message,
            TYPE_NOTIFICATION.ERROR,
            () => {
              navigate("/login");
            }
          );
        }
      })
      .finally(() => {
        setloading(false);
      });
  };

  const handleSubmit = () => {
    setSubmitted(true);
    const isValid = checkDataValidation();
    if (isValid) {
      handleActivateAccount();
    }
  };

  const checkDataValidation = () => {
    if (!isValidEmail(authData.email)) {
      setFormError({
        ...formError,
        mailError: "Veuillez entrer un email valide",
      });
      return false;
    } else {
      setFormError({ ...formError, mailError: null });
      return true;
    }
  };

  useEffect(() => {
    if (AuthService.isConnected()) {
      navigate("/");
    }
    checkDataValidation();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAuthData({ ...authData, [name]: value });
    if (name === "email") {
      setFormError({
        ...formError,
        mailError: isValidEmail(value)
          ? null
          : "Veuillez entrer un email valide",
      });
    } else if (name === "password") {
      setFormError({
        ...formError,
        passwordError:
          value.length >= 6
            ? null
            : "Le mot de passe doit contenir au moins 6 caractères",
      });
    }
  };
  return (
    <>
      <NotificationComponent />
      <DialogComponent />
      <Toast />
      <Grid
        item
        md={4}
        xs={10}
        sm={6}
        lg={4}
        xl={3}
        display={"flex"}
        flexDirection={"column"}
        m={3}
      >
        <Paper sx={{ p: 3 }}>
          <Grid item xs={12} display={"flex"} justifyContent="center">
            {FID_LOGO}
          </Grid>
          <h3>J'ai oublié mon mot de passe</h3>
          <Grid
            container
            display={"flex"}
            flexDirection={"column"}
            justifyContent="center"
            alignItems="center"
          >
            <Grid container display={"flex"} flexDirection={"column"}>
              <FormControl fullWidth>
                <label>Adresse email de recuperation *</label>
                <TextField
                  id="email"
                  name="email"
                  size="small"
                  placeholder="Adresse email"
                  fullWidth
                  onChange={(e) => handleChange(e)}
                  value={authData.email}
                  error={formError.mailError && isSubmitted()}
                  helperText={
                    formError.mailError && isSubmitted()
                      ? formError.mailError
                      : null
                  }
                  aria-describedby="username_helper"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <PermIdentityOutlinedIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid
              item
              display={"flex"}
              justifyContent="center"
              alignItems="center"
              pt={5}
              width={"100%"}
            >
              <LoadingButton
                fullWidth
                loading={loading}
                variant="contained"
                type="submit"
                onClick={handleSubmit}
              >
                Recuperer lien
              </LoadingButton>
            </Grid>
            <Grid
              item
              xs={12}
              mt={2}
              width={"100%"}
              justifyContent={"center"}
              display={"flex"}
              flexDirection={"column"}
            >
              <Divider variant="middle" sx={{ mb: 3 }} />
            </Grid>
            <Grid item xs={12} width={"100%"}>
              <Link to="/login" color="secondary" underline="hover">
                <Button fullWidth>Revenir à la page d'authentification</Button>
              </Link>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default ForgotPassword;
